<template lang="pug">
.redirect-page
</template>

<script>
import { mapMutations } from 'vuex';
import { bindLINE, loginLINE } from '@/site/app/api/line';
import { getProfile } from '@/api/auth';

export default {
  methods: {
    ...mapMutations(['setUserInfo', 'setIsLINELogin']),
    handleCode() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      if (!code) {
        // 取消授權或缺少授權碼時直接回首頁，不再以空授權碼呼叫 LINE API
        this.$router.push('/home');
        return;
      }
      if (state === 'bind') {
        this.$execWithLoading(async () => {
          await bindLINE(code);
          this.$showSuccess('綁定成功');
          this.$router.push('/setting');
          this.setIsLINELogin(true);
        }, (e) => {
          this.$showAxiosException('綁定失敗', e);
          if (e?.response?.status === 401) {
            // 連線過期：$showAxiosException 已導回登入頁
            return;
          }
          // 綁定只會從設定頁發起，失敗時使用者仍在登入狀態，導回設定頁即可
          this.$router.push('/setting');
        });
      } else if (state === 'login') {
        let loggedIn = false;
        this.$execWithLoading(async () => {
          await loginLINE(code);
          loggedIn = true;
          const profile = await getProfile();
          this.setUserInfo(profile);
          this.$router.push({ name: 'Reserves' });
          this.setIsLINELogin(true);
        }, (e) => {
          if (loggedIn) {
            // LINE 登入已成功，是後續讀取個人資料失敗，不能顯示成「尚未綁定」
            this.$showAxiosException('讀取個人資料失敗', e);
            if (e?.response?.status !== 401) {
              this.$router.push('/login');
            }
            return;
          }
          if (e?.response?.data?.error === 'account_disabled') {
            // 後端以 403 account_disabled 表示綁定的會員帳號已被停用
            this.$showError('此帳號已停用，無法登入，如有疑問請聯繫客服');
          } else if (e?.response?.status === 401) {
            // 後端以 401 unauthorized 表示此 LINE 帳號尚未綁定任何會員
            this.$showError('該 LINE 帳號尚未綁定, 請重新使用帳號密碼登入');
          } else {
            this.$showAxiosException('LINE 登入失敗', e);
          }
          this.$router.push('/login');
        });
      } else {
        this.$showError('連結無效，請重新操作');
        this.$router.push('/home');
      }
    },
  },
  mounted() {
    this.handleCode();
  },
};
</script>

<style lang="scss" scoped>

</style>
